import React, { Component } from 'react';

import Field from './Field';
import Input from './Input';
import Label from './Label';
import Icon from './Icon';
import Button from './Button';
import TextArea from './TextArea';
import Select from './Select';
import CreatableSelect from './CreatableSelect';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker'

class Form extends Component {
  render() {
    return (
      <form {...this.props} className={this.props.className}>
        {this.props.children}
      </form>
    );
  }
}

Form.Field = Field;
Form.Input = Input;
Form.Label = Label;
Form.Icon = Icon;
Form.Button = Button;
Form.TextArea = TextArea;
Form.Select = Select;
Form.CreatableSelect = CreatableSelect;
Form.Checkbox = Checkbox;
Form.DatePicker = DatePicker;

export default Form;
